import { getDefaultProjectOptions } from '../getDefaultProjectOptions';
import { TProjectOptions } from '../projectOptions.types';

export function getProjectOptions(isNewEditor = false): TProjectOptions {
  const defaultProjectOptions = getDefaultProjectOptions(isNewEditor);

  const url = window.location.href;
  const urlObj = new URL(url);
  const queryParams = Object.fromEntries(urlObj.searchParams.entries());

  const projectIdFromQueryParam = queryParams?.projectId as string | undefined;

  return {
    name: '',
    productConfigurationId:
      (queryParams?.productConfigurationId as string) ?? defaultProjectOptions.productConfigurationId,
    //productFamily: (queryParams?.productFamily as string) ?? defaultProjectOptions.productFamily,
    groupCode: (queryParams?.groupCode as string) ?? defaultProjectOptions.groupCode,
    projectId: projectIdFromQueryParam ?? defaultProjectOptions.projectId,
  };
}
